var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.90845 6.48494V14.5933C1.90845 16.1766 3.03345 16.8266 4.40011 16.0433L6.35845 14.9266C6.78345 14.6849 7.49178 14.6599 7.93345 14.8849L12.3084 17.0766C12.7501 17.2933 13.4584 17.2766 13.8834 17.0349L17.4918 14.9683C17.9501 14.7016 18.3334 14.0516 18.3334 13.5183V5.40994C18.3334 3.82661 17.2084 3.17661 15.8418 3.95994L13.8834 5.07661C13.4584 5.31827 12.7501 5.34327 12.3084 5.11827L7.93345 2.93494C7.49178 2.71827 6.78345 2.73494 6.35845 2.97661L2.75011 5.04327C2.28345 5.30994 1.90845 5.95994 1.90845 6.48494Z",
    stroke: "#FCFCFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1333 3.33594V14.1693",
    stroke: "#FCFCFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1084 5.51758V16.6676",
    stroke: "#FCFCFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/map-Icon.c62a3765e3e600217f696bace1a03bf4.svg";
export { ForwardRef as ReactComponent };